export default __webpack_public_path__ + "static/media/pl.feaa3a17.svg";